import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=2f28fda4&scoped=true&"
import script from "./apply.vue?vue&type=script&lang=js&"
export * from "./apply.vue?vue&type=script&lang=js&"
import style0 from "./apply.vue?vue&type=style&index=0&id=2f28fda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28fda4",
  null
  
)

export default component.exports